import { useSelector } from 'react-redux'
import type { DurationInputArg2, Moment } from 'moment'
import {
  DateUtils,
  LanguageUtils,
  moment,
  type Nil,
  Utils,
} from '@pbt/pbt-ui-components'

import {
  getEventState,
  getReminderProtocolTimeUnits,
} from '~/store/reducers/constants'
import type {
  Reminder,
  ReminderByUser,
  ReminderGroup,
  ReminderStateName,
} from '~/types'
import { getTimeUnitListPluralized } from '~/utils/time'

export const dateOffsetToDate = (
  amount: any,
  unitName: DurationInputArg2,
  base?: Moment,
) => moment(base || new Date()).add(amount, unitName)

export const getReminderGroupName = (group: ReminderGroup) => {
  const type = group.type || group.itemType

  return group.month ? `${type}-${group.month}` : type
}

export const getReminderTriggerLabel = (triggeredBy: ReminderByUser) => {
  const { itemName, datetime, person } = triggeredBy

  return [
    itemName,
    datetime && DateUtils.formatDate(datetime),
    person && Utils.getPersonString(person),
  ]
    .filter(Boolean)
    .join(' | ')
}

export const useGetDueDateString = (
  offset: {
    amount: number
    unit: string
  } | null,
) => {
  const TimeUnits = useSelector(getReminderProtocolTimeUnits)
  const LocalizedTimeUnits = getTimeUnitListPluralized(
    TimeUnits,
    offset?.amount || 0,
  )
  const unitName = LanguageUtils.getConstantTranslatedName(
    offset?.unit,
    LocalizedTimeUnits,
    '',
  ).toLowerCase()

  return offset?.amount
    ? `+${offset?.amount} ${unitName}`.toLowerCase().trim()
    : ''
}

export const useIsReminderStateName = (
  reminder: Reminder | Nil,
  state: ReminderStateName,
) => {
  const EventState = useSelector(getEventState)

  return reminder?.state?.id === Utils.findConstantIdByName(state, EventState)
}
